<template>
    <section class="label-autocomplete-option" :data-focused="focused" ref="labelAutocompleteOption" @click="onClick">
        <div v-if="labelNode.layout.color" class="color" :style="{
            background: labelNode.layout.color,
        }"></div>
        <span class="title">
            <highlightText :text="labelNode.layout.caption" :highlightedText="searchText" />

            <badgeUI v-if="insertedOnReport" class="report-badge">
                no relatório
            </badgeUI>
        </span>
        <span class="enter-icon">↵</span>
    </section>
</template>

<script>
import highlightText from '@/components/ui/text/highlightText.vue';
import badgeUI from '@/components/ui/badge/badge.vue';

export default {
    name: 'labelAutocompleteOption',
    components: {
        highlightText,
        badgeUI
    },
    props: {
        labelNode: {
            type: Object,
            required: true
        },
        searchText: {
            type: String,
            required: true
        },
        focused: {
            type: Boolean,
            default: false
        },
        insertedOnReport: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        focused(newVal) {
            if (newVal) {
                this.$refs.labelAutocompleteOption.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }
    },
    methods: {
        onClick() {
            this.$emit('click');
        }
    }
}
</script>

<style scoped>

.label-autocomplete-option {
    display: flex;
    align-items: center;
    gap: var(--spacing-sm);
    padding: var(--spacing-sm) var(--spacing-md);
    cursor: pointer;
    border-radius: var(--radius-sm);
    transition: opacity 0.2s ease, background-color 0.2s ease;
}

.label-autocomplete-option[data-focused="true"] {
    outline: 1px solid var(--color-primary);
    outline-offset: -1px;
}

.label-autocomplete-option:hover, .label-autocomplete-option[data-focused="true"] {
    opacity: 0.8;
    background-color: var(--background-light-gray);
}

.label-autocomplete-option:active {
    scale: 0.98;
}

.label-autocomplete-option .color {
    display: inline-block;
    width: 14px;
    height: 14px;
    border-radius: 5px;
    flex-shrink: 0;
}

.label-autocomplete-option .title {
    display: flex;
    align-items: center;
    gap: var(--spacing-xs);
    font-family: var(--font-family-primary);
    font-size: var(--text-sm);
    font-weight: 600;
    color: var(--color-black);
    flex: 1;
    transition: color 0.2s ease;
}

.label-autocomplete-option[data-focused="true"] .title {
    color: var(--color-primary);
}

.label-autocomplete-option .enter-icon {
    font-size: var(--text-xs);
    font-weight: 600;
    color: var(--color-dark-gray);
    flex-shrink: 0;
    opacity: 0;
    transition: opacity 0.2s ease;
}

.label-autocomplete-option[data-focused="true"] .enter-icon {
    opacity: 1;
}

.report-badge {
    margin-left: var(--spacing-xs);
    opacity: 0.8;
}

</style>